import React, { useEffect, useRef } from "react"

const CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789" // no confusing 0/O/1/l/I

export const generateCaptcha = (len = 5) =>
  Array.from({ length: len }, () => CHARS[Math.floor(Math.random() * CHARS.length)]).join("")

const Captcha = ({ code, onRefresh }) => {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext("2d")
    const { width, height } = canvas

    ctx.fillStyle = "#f1f3f5"
    ctx.fillRect(0, 0, width, height)

    // noise lines
    for (let i = 0; i < 6; i++) {
      ctx.strokeStyle = `hsl(${Math.random() * 360}, 40%, 60%)`
      ctx.beginPath()
      ctx.moveTo(Math.random() * width, Math.random() * height)
      ctx.lineTo(Math.random() * width, Math.random() * height)
      ctx.stroke()
    }

    // characters with random rotation/colour
    const step = width / (code.length + 1)
    code.split("").forEach((ch, i) => {
      ctx.save()
      ctx.translate(step * (i + 1), height / 2 + 8)
      ctx.rotate((Math.random() - 0.5) * 0.6)
      ctx.font = `bold ${26 + Math.random() * 6}px Arial`
      ctx.fillStyle = `hsl(${Math.random() * 360}, 60%, 30%)`
      ctx.fillText(ch, -8, 0)
      ctx.restore()
    })

    // noise dots
    for (let i = 0; i < 40; i++) {
      ctx.fillStyle = "rgba(0,0,0,0.3)"
      ctx.fillRect(Math.random() * width, Math.random() * height, 2, 2)
    }
  }, [code])

  return (
    <div className="d-flex align-items-center gap-2">
      <canvas ref={canvasRef} width={170} height={50} style={{ borderRadius: 6, border: "1px solid #d4d4d4" }} />
      <button type="button" className="btn btn-outline-secondary" onClick={onRefresh} title="Refresh captcha">
        <i className="mdi mdi-refresh"></i>
      </button>
    </div>
  )
}

export default Captcha